import { useTranslation } from "react-i18next";

import { Alert, Box, Stack, Typography } from "@mui/material";

import { formatEuro } from "../../../../../../../../format/formatNumber";
import { roundToCents } from "../../../../../../../../utils/roundToCents";
import { AssetExpenseSummaryResponse } from "../../../../../../../api/ClientFileApi";

const SECTION = "clients.client.debtSettlement.assetInventory.expensesTab.summary";

interface Props {
  summary: AssetExpenseSummaryResponse;
  totalExpenses: number;
  saveAttempted: boolean;
}

export function ExpenseSummary({ summary, totalExpenses, saveAttempted }: Props) {
  const { t, i18n } = useTranslation();

  if (!summary.isIncomeAvailable || totalExpenses <= 0) {
    return null;
  }

  const remaining = roundToCents(summary.totalIncome - totalExpenses);
  const rows = [
    {
      label: t(`${SECTION}.totalIncome`, { seizable: formatEuro(summary.seizableAmount, i18n.language) }),
      value: summary.totalIncome,
    },
    { label: t(`${SECTION}.totalExpenses`), value: totalExpenses },
    { label: t(`${SECTION}.remaining`), value: remaining },
  ];

  return (
    <Stack gap={1}>
      <Box component="dl" sx={{ display: "grid", gridTemplateColumns: "1fr auto", columnGap: 2, rowGap: 0.5, m: 0 }}>
        {rows.map((row) => (
          <Box key={row.label} sx={{ display: "contents" }}>
            <Typography component="dt">{row.label}</Typography>
            <Typography component="dd" sx={{ m: 0, textAlign: "right" }}>
              {formatEuro(row.value, i18n.language)}
            </Typography>
          </Box>
        ))}
      </Box>
      {saveAttempted && remaining < 0 && (
        <Alert severity="error" role="alert">
          {t(`${SECTION}.expensesExceedIncome`)}
        </Alert>
      )}
    </Stack>
  );
}
